import { CollectionItemsViewSelector } from './CollectionItemsViewSelector';
import { COLLECTION_LAYOUT_LIST } from '../../utils/constans/collectionLayoutSelectorList';
import { CollectionListWrapper } from './CollectionListWrapper';
import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Product } from '../../models/Product';
import { useTranslation } from 'react-i18next';
import { CollectionLoadingLayout } from '../layouts/LoadingLayouts/CollectionLoadingLayout';
import { CollectionActionWrapper } from './CollectionActionsWrapper';
import { CollectionGridWrapper } from './CollectionGridWrapper';

export const CollectionWrapper: React.FC<CollectionWrapperProps> = (props) => {
    const [selectedLayout, setSelectedLayout] = useState(
        COLLECTION_LAYOUT_LIST[0]
    );
    const { products, handle, isProductsLoading, isProductsError, handleSort } =
        props;
    const { t } = useTranslation('collection');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleSelectLayout = (id) => {
        setSelectedLayout(COLLECTION_LAYOUT_LIST.find((elem) => elem.id == id));
    };

    return (
        <>
            <CollectionActionWrapper
                handleSelectLayout={handleSelectLayout}
                selectedLayout={selectedLayout.id}
                handleSortSelect={handleSort}
            />
            {isProductsLoading && <CollectionLoadingLayout />}
            {isProductsError && (
                <Box>{t('COLLECTIONS.REQUEST_ERROR').toUpperCase()}</Box>
            )}
            {products && products.length > 0 && (
                <Box>
                    {(selectedLayout.type == 'list' && !isMobile) && (
                        <CollectionListWrapper
                            products={products}
                            handle={handle}
                        />
                    )}
                    {(selectedLayout.type == 'grid' || isMobile)&& (
                        <CollectionGridWrapper
                            gridSize={isMobile ? 1 : selectedLayout.gridSize}
                            products={products}
                            handle={handle}
                        />
                    )}
                </Box>
            )}
            {products && products.length == 0 && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '10px 0',
                        fontSize: '16px',
                    }}
                >
                    {t('COLLECTIONS.NO_PRODUCTS').toUpperCase()}
                </Box>
            )}
        </>
    );
};

type CollectionWrapperProps = {
    products: Product[];
    handle: string;
    isProductsLoading: boolean;
    isProductsError: boolean;
    handleSort: (sort) => void;
};
